import {
  Autocomplete,
  Box,
  colors,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import DropZone from "components/Dropzone_one";
import { useEffect, useState } from "react";
import nationalities from "data/nationalities_th.json";
import { PrefixOptions } from "contants/options";
import WatermarkedImage from "./WatermarkImage";

const fields = [
  {
    label: "คำนำหน้า",
    name: "prefix",
    type: "autocomplete",
    required: true,
    options: PrefixOptions,
    defaultValue: "นาย",
  },
  { label: "ชื่อ-นามสกุล", name: "fullName", type: "text", required: true },
  {
    label: "เลขบัตรประชาชน/ Passport No.",
    name: "idCardNumber",
    type: "text",
    required: true,
    inputProps: {
      maxLength: 20,
      minLength: 6,
      inputMode: "text",
      pattern: "[A-Za-z0-9]*",
    },
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    required: true,
    inputProps: {
      minLength: 9,
      maxLength: 10,
      inputMode: "numeric",
      pattern: "[0-9]*",
    },
  },
  { label: "ที่อยู่", name: "address", type: "text", required: true },
  {
    label: "สัญชาติ",
    name: "nationality",
    type: "autocomplete",
    required: true,
    options: nationalities,
    defaultValue: "ไทย",
  },
];

const RenderFieldsCustomerPawn = ({
  sx,
  formik,
  setCustomerImage,
  images = null,
  errorImages = null,
  isEdit = false,
  type = "buy",
  ...props
}) => {
  const [files, setFiles] = useState(images ? images : []);
  const [error, setError] = useState(null);

  // 🧠 sync images จาก parent → local files (พร้อมกัน loop)
  useEffect(() => {
    console.log({
      images,
      files,
      isEdit,
    });
    if (!isEdit) {
      if (!images) {
        if (files.length !== 0) setFiles([]);
        return;
      }

      const newFiles = Array.isArray(images) ? images : [images];

      const isSame =
        newFiles.length === files.length &&
        newFiles.every(
          (f, i) =>
            f.url === files[i]?.url &&
            f.name === files[i]?.name &&
            f.status === files[i]?.status
        );

      if (!isSame) {
        setFiles(newFiles);
      }
    }
  }, [images, isEdit]);

  // 🧠 ส่งกลับ parent เฉพาะเมื่อ files เปลี่ยนจริง ๆ (กัน loop)
  useEffect(() => {
    if (!Array.isArray(files)) return;

    const same =
      Array.isArray(images) &&
      files.length === images.length &&
      files.every(
        (f, i) =>
          f.url === images[i]?.url &&
          f.name === images[i]?.name &&
          f.status === images[i]?.status
      );

    if (!same) {
      setCustomerImage(files);
    }
  }, [files]);

  // useEffect(() => {
  //   if (files.length > 0) {
  //     setCustomerImage(files);
  //   } else {
  //     setCustomerImage([]);
  //   }
  // }, [files]);

  return (
    <Box sx={{ ...sx }}>
      <Typography variant="h5" sx={{ mb: 1, ml: 2 }}>
        ข้อมูลลูกค้า
      </Typography>
      <Box
        sx={{
          p: 2,
          backgroundColor: "white",
          borderRadius: 3,
          border: `1px solid ${colors.grey[300]}`,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={7}>
            {fields.map((field, index) => (
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  mt: 1,
                }}
                key={index}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "baseline",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      width: "200px",
                      lineHeight: "20px",
                    }}
                  >
                    {field.label}
                    {field.required && <span style={{ color: "red" }}>*</span>}
                  </Typography>
                  {field.type === "autocomplete" ? (
                    field.name === "nationality" ? (
                      <Autocomplete
                        disablePortal
                        disableClearable
                        options={nationalities || []}
                        getOptionLabel={(option) => option.nationality || ""}
                        value={
                          nationalities.find(
                            (n) =>
                              n.nationality ===
                              (formik.values[field.name] || "ไทย")
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          formik.setFieldValue(
                            "nationality",
                            newValue?.nationality || "ไทย"
                          );
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.nationality === value?.nationality
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder={field.placeholder}
                            required={field.required}
                            error={
                              formik.touched[field.name] &&
                              Boolean(formik.errors[field.name])
                            }
                            helperText={
                              formik.touched[field.name] &&
                              formik.errors[field.name]
                                ? formik.errors[field.name]
                                : ""
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                bgcolor: "white",
                                height: "40px",
                              },
                            }}
                          />
                        )}
                        fullWidth
                        disabled={props.disabled}
                      />
                    ) : (
                      <Autocomplete
                        {...props}
                        disablePortal
                        options={field.options || []}
                        value={formik.values[field.name] || null}
                        onChange={(event, newValue) => {
                          formik.setFieldValue(field.name, newValue || "");
                        }}
                        onBlur={() => formik.setFieldTouched(field.name, true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder={field.placeholder}
                            required={field.required}
                            error={
                              formik.touched[field.name] &&
                              Boolean(formik.errors[field.name])
                            }
                            helperText={
                              formik.touched[field.name] &&
                              formik.errors[field.name]
                                ? formik.errors[field.name]
                                : ""
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                bgcolor: "white",
                                height: "40px",
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        fullWidth
                      />
                    )
                  ) : (
                    <TextField
                      {...props}
                      fullWidth
                      type={field.type}
                      variant="outlined"
                      name={field.name}
                      placeholder={field.placeholder}
                      required={field.required}
                      value={formik.values[field.name] || ""}
                      error={
                        formik.touched[field.name] &&
                        Boolean(formik.errors[field.name])
                      }
                      helperText={
                        formik.touched[field.name] && formik.errors[field.name]
                          ? formik.errors[field.name]
                          : ""
                      }
                      onBlur={formik.handleBlur}
                      onChange={(e) => {
                        // Update the data state with the new value
                        formik.setFieldValue(field.name, e.target.value);
                      }}
                      onKeyPress={
                        field.inputProps &&
                        field.inputProps.inputMode === "numeric"
                          ? (e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }
                          : null
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          bgcolor: "white",
                          height: "40px",
                        },
                      }}
                      inputProps={field.inputProps || {}}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
          <Grid item xs={5} sx={{ mt: 1 }}>
            {props.disabled && isEdit && images ? (
              <Box sx={{ padding: 1, width: "100%", height: "214px" }}>
                {images || (Array.isArray(images) && images.length > 0) ? (
                  <WatermarkedImage
                    src={images ?? images[0] ?? images[0]?.url}
                    alt="customer"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#F8F7FD",
                      color: "#B0B0B0",
                    }}
                  >
                    ไม่มีรูปภาพ
                  </Box>
                )}
              </Box>
            ) : (
              <>
                {error ? (
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    {error}
                  </Typography>
                ) : errorImages ? (
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    {errorImages}
                  </Typography>
                ) : null}
                <DropZone
                  files={Array.isArray(files) ? files : []}
                  setFiles={setFiles}
                  setError={setError}
                  maxFiles={1}
                />
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default RenderFieldsCustomerPawn;
